import React from 'react';
import PropTypes from 'prop-types';
import {parse} from 'query-string';
import Dashboard from 'common/components/dashboard';
import {getColorBasedOnContrast} from 'common/utils/color-util';
import './index.scss';

export default class StoryboardReportRenderer extends React.Component {
  static propTypes = {
    data: PropTypes.object.isRequired,
    enums: PropTypes.object.isRequired,
    handleScroll: PropTypes.func,
    location: PropTypes.object.isRequired,
    report: PropTypes.object.isRequired,
  };

  static defaultProps = {
    handleScroll: () => {},
    report: null,
  };

  componentDidMount() {
    // JQuery in a React component... puke.
    // But using raw JS seems not to work.
    // $ only listens for scroll event.
    // No DOM inspection or manipulation.
    $('.StoryboardReportRenderer').on('scroll', this.props.handleScroll);
  }

  shouldComponentUpdate(nextProps) {
    // VERY IMPORTANT: Prevent update on scroll,
    // Otherwise CPU is crushed and rendering grinds.
    if (
      nextProps.data !== this.props.data ||
      nextProps.location !== this.props.location ||
      nextProps.report !== this.props.report
    ) {
      return true;
    }
    return false;
  }

  componentWillUnmount() {
    // JQuery in a React component... puke.
    // But using raw JS seems not to work.
    // $ only listens for scroll event.
    // No DOM inspection or manipulation.
    $('.StoryboardReportRenderer').off('scroll', this.props.handleScroll);
  }

  getRendererForContentType(report, showTitle, titleStyle) {
    let {chapterId} = parse(this.props.location.search);
    chapterId = parseInt(chapterId, 10);
    return (
      <Dashboard
        dashboard={report.meta}
        hasBackground={false}
        hasMinHeight={false}
        inStoryboard={true}
        readonly={true}
        report={report}
        showTitle={showTitle}
        storyboardChapterId={chapterId}
        titleStyle={titleStyle}
        userCanEditDashboard={false}
      />
    );
  }

  getTitleStyle(data) {
    const {theme} = data.configuration;
    if (theme && theme.backgroundColors && theme.backgroundColors.length) {
      const color = getColorBasedOnContrast(theme.backgroundColors[0]);
      return {
        color,
      };
    }
    return {};
  }

  shouldShowTitle(data, location) {
    const {chapterId} = parse(location.search);
    const currentChapter = data.chapters
      .filter((chapter) => parseInt(chapter.id, 10) === parseInt(chapterId, 10))
      .shift();
    return currentChapter ? currentChapter.showTitle : false;
  }

  render() {
    const showTitle = this.shouldShowTitle(
      this.props.data,
      this.props.location,
    );
    const titleStyle = this.getTitleStyle(this.props.data);
    return (
      <div className={'StoryboardReportRenderer'}>
        {this.getRendererForContentType(
          this.props.report,
          showTitle,
          titleStyle,
        )}
      </div>
    );
  }
}
